import {useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CircledIcon from '../../../components/CircledIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Label from '../../../components/Label/Label';
import IconButton from '../../../components/IconButton';
import PopoverWithLinks from '../../widgets/PopoverLinks/PopoverLinks';

const AllBenefits = () => {
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <Container className={'px-0'}>
      <Row className={'mt-8'}>
          <Col className={'col-12 col-lg-6'}>
              <h5 className="text-20 pb-0 mb-0">All Benefits</h5>
          </Col>
      </Row>
      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h4>Medical</h4>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>Your medical election include prescription drug coverage.</li>
                      <li>If you decline coverage, you will be forfeiting your COBRA continuation coverage and will be unable to re-enroll.</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>Medical</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                  You Only
                </Col>
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Copay Option</span></div></div>
                  <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>Initial COBRA payment required *</span></div></div>
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'Edit',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'View',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={3} className="text-center py-10">
                    $819.06
                </Col>
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Gold HSA</span></div></div>
                  <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>Initial COBRA payment required *</span></div></div>
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'Edit',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'View',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={3} className="py-10 text-center bg-primary text-white">
                    $819.06
                </Col>
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Silver HSA</span></div></div>
                  <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>Initial COBRA payment required *</span></div></div>
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'Edit',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'View',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={3} className="text-center py-10">
                    $819.06
                </Col>
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                </Col>
                <Col lg={3} className="text-end py-5"></Col>
                <Col lg={3} className="text-center py-10">
                    $0.00
                </Col>
              </Row>
            </Container>
          </GenericCard>
        </Col>
      </Row>
    </Container>
  )
}

export default AllBenefits